import { ClipboardPlus, Eye, FileSignature, RotateCcw } from "lucide-react";

export const ASSESSMENT_TYPES = [
  { value: "admission", label: "Admission", icon: ClipboardPlus, color: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  { value: "supervisory", label: "Supervisory Visit", icon: Eye, color: "bg-sky-100 text-sky-800 border-sky-200" },
  { value: "readmission", label: "Re-Admission", icon: RotateCcw, color: "bg-amber-100 text-amber-800 border-amber-200" },
  { value: "admission_forms", label: "Admission Forms", icon: FileSignature, color: "bg-violet-100 text-violet-800 border-violet-200", paperwork: true },
];

export const TYPE_META = Object.fromEntries(ASSESSMENT_TYPES.map((t) => [t.value, t]));

export const fmtDate = (d) => {
  if (!d) return "";
  const [y, m, day] = String(d).slice(0, 10).split("-");
  return y && m && day ? `${m}/${day}/${y}` : d;
};
